module.exports = __webpack_public_path__ + "img/money_creditor.fbbf634f.png";